<app-logo-header></app-logo-header>
<section class="section">
  <div class="container">
    <div class="fail-card mx-auto p-3">
      <div class="text-center mb-3">
        <img src="../../../../../assets/images/easykash-logo-fail.png" />
      </div>
      <div class="card shadow-lg p-3 mb-3">
        <div class="text-center text-danger">
          <svg aria-hidden="true" focusable="false" data-prefix="fad" height="48" width="48"
               data-icon="times-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208.9 208.9">
            <circle fill="#e1253c" cx="104.4" cy="104.4" r="104.4" />
            <path fill="#8f1d2c" d="M49.7,138.8L84,104.4L49.7,70l20.4-20.4L104.4,84l34.4-34.4L159.2,70l-34.4,34.4l34.4,34.4l-20.4,20.4
              	l-34.4-34.4L70,159.2L49.7,138.8z" />
          </svg>
          <h5 class="text-danger fw-bold">{{ title }}</h5>
        </div>
        <p>
          {{ message }}
        </p>
      </div>
      <div class="d-flex">
        <button [routerLink]="redirectURL"
                class="btn btn-danger col-12">Continue</button>
      </div>
    </div>
  </div>
</section>
